import Box, { BoxProps } from '@mui/material/Box';
import { forwardRef, ReactNode } from 'react';

export interface SectionProps extends Omit<BoxProps, 'component'> {
  children?: ReactNode;
}

const Section = forwardRef<HTMLElement | null, SectionProps>(function Section(
  { children, sx, ...rest },
  ref
) {
  return (
    <Box ref={ref} component="section" sx={sx} {...rest}>
      {children}
    </Box>
  );
});

export default Section;
